import { isCheckoutBlockedByWarnings } from '@insurance/utils'
import { Form } from 'antd'

import { InsurancePaymentControls } from '../InsurancePaymentControls'

import { useRcaInsuranceValues } from './RcaInsuranceContext'
import { RcaFormValues } from './types'
import {
  formProps,
  normalizeOrderData,
  removeRcaValuesFromStorage
} from './utils'

type Props = {
  steps: number
  onReadyToSaveData?: () => void
}

export const RcaInsuranceControls = ({ steps, onReadyToSaveData }: Props) => {
  const { handleCalculate, isCalculatingLoading, order } =
    useRcaInsuranceValues()
  const { orderKey, warningsKey } = formProps()

  const underwritingWarnings = Form.useWatch(warningsKey.name, {
    preserve: true
  })

  const isCheckoutBlocked = isCheckoutBlockedByWarnings(underwritingWarnings)

  return (
    <InsurancePaymentControls
      steps={steps}
      onReadyToSaveData={onReadyToSaveData}
      removeFromStorage={() => removeRcaValuesFromStorage(order?.id)}
      handleCalculate={handleCalculate}
      isCalculatingLoading={isCalculatingLoading}
      errorUnwrapKeys={['rca']}
      normalizeOrderData={(values) => ({
        id: values[orderKey.name] as number,
        requestBody: { rca: normalizeOrderData(values as RcaFormValues) }
      })}
      disabledPay={isCheckoutBlocked}
    />
  )
}
